export const RESOLUTION_STATUS_COLORS: Record<string, string> = {
  // Unified 4-status
  confirmed_resolution: 'hsl(160 84% 39%)',
  assumed_resolution: 'hsl(158 60% 62%)',
  unresolved: 'hsl(0 75% 65%)',
  small_talk: 'hsl(220 8% 72%)',
  // Legacy 2-status
  resolved: 'var(--chart-positive)',
};
